import { Component, OnInit, TemplateRef } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TicketService } from 'src/app/Service/Ticket/Ticket.service';
import { TicketCategoryService } from 'src/app/Service/TicketCategory/TicketCategory.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-TicketAdminForm',
  templateUrl: './TicketAdminForm.component.html',
  styleUrls: ['./TicketAdminForm.component.scss']
})
export class TicketAdminFormComponent implements OnInit {

  Title:string=""
  TicketCategory:string="0"
  Token:String=""
  public Editor = ClassicEditor;
  public model = {
    editorData: '<p>Type your text here...</p>'
};
  public config = {
    language: 'fa'
};

  constructor(
    private Alertify_Service:AlertifyService,
    private Ticket_Service:TicketService,
    private TicketCategory_Service:TicketCategoryService,
    private modalService: BsModalService,
    private Customer_Service:CustomerService,
    private Nav_Service:NavService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');


    this.Nav_Service.CheckValidPage(this.Token,1104).subscribe(
      data=>{
        this.Read_TicketCategory()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#region Ticket Category

  TicketCategory_DataList:Array<General_Interface>
  Read_TicketCategory(){
    this.InProccessing=true
    this.TicketCategory_Service.GetActiveList(this.Token).subscribe(
      data=>{
        this.InProccessing=false
        this.TicketCategory_DataList=data
      },error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  //#endregion

  //#region Image
  BaseUrl=environment.BaseUrl
  UploadImageSrc_List:Array<string>=[]
  UploadImageSrc:string=''
  InProccessing_Image1:boolean=false
  uploadImage1(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (const file of files) {
      formData.append(file.name, file);
    }

    this.InProccessing_Image1=true

    this.Ticket_Service.uploadFile(formData,this.Token).subscribe(
      data=>{
        this.InProccessing_Image1=false
        if(data['id']==0)
        {
          this.Alertify_Service.ErrorMessage(data['filename'])
        }
        else{
          this.Alertify_Service.SuccessMessage("File uploaded successfully.")
          this.UploadImageSrc=data['filename']
        }
      }
    )

  }

  Remove_uploadImage1(){
    this.UploadImageSrc=''
  }

  Add_uploadImage1(){
    this.UploadImageSrc_List.push(this.UploadImageSrc)
    this.UploadImageSrc=''
    this.Alertify_Service.SuccessMessage("Added to the table.")
  }

  UploadImageSrc_List_Delete(id:number)
      {
        this.UploadImageSrc_List.splice(id,1)
        this.Alertify_Service.SuccessMessage("Deleted successfully.")
      }

    modalRef_Image: any;
    ModalimageUrl:string=''
    openModal(template: TemplateRef<any>,imageUrl:string) {
      this.ModalimageUrl=imageUrl
      this.modalRef_Image = this.modalService.show(template);
    }

//#endregion


  //#region Customer
  ProcssingCustomer:boolean=false
  modalRef_Customer: any;
  modalRef_CustomerAdress: any;
  page:number=0


  Search_CodeName_Customer_Table:string=''
  Search_Type_Customer_Table:string='2'

  DataList_Customer:Array<Customer_List_Interface>=[]
  Selected_DataList_Customer:Array<Customer_List_Interface>=[]

  ReadData_Customer_KeySearch_Timer:any
  ReadData_Customer_KeySearch(){

    if (this.ReadData_Customer_KeySearch_Timer) {
      clearTimeout(this.ReadData_Customer_KeySearch_Timer);
      this.ReadData_Customer_KeySearch_Timer = null;
  }

  this.ReadData_Customer_KeySearch_Timer = setTimeout(function (){
    this.ReadData_Customer()
  }.bind(this), 1000);

  }

  ReadData_Customer(){

    if(!this.Search_CodeName_Customer_Table)
    {
      this.DataList_Customer=[]
    }
    else{


      this.ProcssingCustomer=true
        this.Customer_Service.GetSearchCalibration(this.Token,this.Search_CodeName_Customer_Table).subscribe(
          data=>{
            this.DataList_Customer=data
            this.ProcssingCustomer=false
          },error=>{
            localStorage.clear()
            location.reload();

          }
        )
    }
  }

  openModal_Customer(template: TemplateRef<any>) {
    this.modalRef_Customer = this.modalService.show(template);
  }

  openModal_CustomerAddress(template: TemplateRef<any>) {
    this.modalRef_CustomerAdress = this.modalService.show(template);
  }

  Set_Selected_Customer_Record(item){

    if(this.Check_Douplicate_Customer(item))
    {
      this.Selected_DataList_Customer.push(item)
      this.modalRef_Customer.hide()
      this.Alertify_Service.SuccessMessage("The customer was added to the list.")
    }
    else{
      this.Alertify_Service.ErrorMessage("The selected customer has already been added.")
    }

  }

  Check_Douplicate_Customer(record:Customer_List_Interface)
  {
    for(let item of this.Selected_DataList_Customer)
    {
       if(item.id == record.id)
          return false
    }
    return true
  }

  Customer_List_Delete(id:number)
  {
    this.Selected_DataList_Customer.splice(id,1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
  }


  //#endregion


  InProccessing:boolean=false
  onSubmitForm(){

    if(!this.Title)
    {
      this.Alertify_Service.ErrorMessage("Enter the ticket title.")
    }
    else if(this.Title.trim().length > 50)
    {
      this.Alertify_Service.ErrorMessage("The ticket title must not exceed 50 characters.")
    }
    else if(this.Selected_DataList_Customer.length==0)
    {
      this.Alertify_Service.ErrorMessage("Select at least one customer.")
    }
    else if(this.TicketCategory=="0")
    {
      this.Alertify_Service.ErrorMessage("Select a ticket category.")
    }
    else{

      this.InProccessing=true
      this.Ticket_Service.SubmitTicketAdmin(
        this.model.editorData,
        this.Selected_DataList_Customer,
        this.Title.trim(),
        Number(this.TicketCategory),
        this.Token,
        this.UploadImageSrc_List
        ).subscribe(
        data=>{
          this.model.editorData='<p>Type your text here...</p>'
          this.Title=""
          this.TicketCategory="0"
          this.Selected_DataList_Customer=[]
          this.UploadImageSrc_List=[]
          this.Alertify_Service.SuccessMessage("The ticket was submitted successfully.")
          this.InProccessing=false
        },error=>{
          localStorage.clear()
          location.reload();
        }
      )

    }

  }

}
